const jQParam = a => {
   const s = [];
   const add = function(k, v) {
      v = typeof v === 'function' ? v() : v;
      if (v === null || v === undefined) {
         v = '';
      }
      s[s.length] = `${encodeURIComponent(k)}=${encodeURIComponent(v)}`;
   };
   const buildParams = function(prefix, obj) {
      let i;
      let len;

      if (prefix) {
         if (Array.isArray(obj)) {
            for (i = 0, len = obj.length; i < len; i++) {
               buildParams(
                  `${prefix}[${typeof obj[i] === 'object' && obj[i] ? i : ''}]`,
                  obj[i],
               );
            }
         } else if (Object.prototype.toString.call(obj) === '[object Object]') {
            Object.keys(obj)
               .forEach(key => {
                  buildParams(`${prefix}[${key}]`, obj[key]);
               });
         } else {
            add(prefix, obj);
         }
      } else if (Array.isArray(obj)) {
         for (i = 0, len = obj.length; i < len; i++) {
            add(obj[i].name, obj[i].value);
         }
      } else {
         Object.keys(obj)
            .forEach(key => {
               buildParams(key, obj[key]);
            });
      }
      return s;
   };

   return buildParams('', a)
      .join('&');
};

export { jQParam };
